import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { Admindashboard } from '../AdminDashboard/admindashboard'
import { SchoolTickets } from '../SchoolTickets'
import { IndexSchools } from '../Schools'
import RepairDetails from '../../Components/RepairDetails'
import { IncomingBatches } from '../IncomingBatch'
import { AdminBilling } from '../Billingandtickets/AdminBilling'
import TicketHistoryPage from '../Billingandtickets/TicketHistoryPage'
import { CreateTicket } from '../CreateTicket'
import { AddUpdate } from '../ManageDevice/addupdate'
import { Technician } from '../Technician'
import { ErrorPage } from '../404Error'
import { ReportsIndex } from '../AdminReports'
import { FaqIndex } from '../FAQ'
import SSInfoOnly from '../SSInfoOnly'
import { ImportExport } from '../ImportExport'
import SchoolProfile from '../SchoolProfile'
import Notification from '../Notification'
import { ManageTicket } from '../ManageTicket'
import { ManageParts } from '../ManagePart'
import { ShipDevices } from '../ShipDevices'
import MassTicket from '../MassTicket'
import Outgoingbatches from '../ShipDevices/Outgoingbatches'
import { ManageDeviceIndex } from '../ManageDevice'
import { IndexUsers } from '../ManageUsers'
import { UsersAddUpdate } from '../ManageUsers/addupdate'
import { StaffMemberIndex } from '../StaffMember'
import Building from '../Building'
import UsersGroup from '../UsersGroup'
import PreviousAudits from '../InventoryAudit/PreviousAudits'
import InventoryAudit from '../InventoryAudit'
import RolesIndex from '../Roles'
import DeviceCustomField from '../CustomField/Index'

export default function Access17() {
    return (
        <Routes>
            <Route exact path="/" element={<Admindashboard />} />
            <Route exact path="/dashboard" element={<Admindashboard />} />
            <Route exact path="/schools" element={<IndexSchools />} />
            <Route exact path="/school-tickets/*" element={<SchoolTickets />} />
            <Route exact path="/repair-details/*" element={<RepairDetails />} />
            <Route exact path="/incoming-batches/*" element={<IncomingBatches />} />
            <Route exact path="/admin-invoice" element={<AdminBilling />} />
            <Route exact path="/ticket-history" element={<TicketHistoryPage />} />
            <Route exact path="/create-ticket" element={<CreateTicket />} />
            <Route path="/addupdate-device/*" element={<AddUpdate />} />
            <Route exact path="/technician" element={<Technician />} />
            <Route exact path="*" element={<ErrorPage />} />
            <Route exact path="/reports" element={<ReportsIndex />} />
            <Route exact path="/faqs" element={<FaqIndex />} />
            <Route exact path="/notifications" element={<Notification />} />
            <Route path="/sprig-statistics" element={<SSInfoOnly />} />
            <Route exact path="/import-export" element={<ImportExport />} />
            <Route exact path="/school-profile" element={<SchoolProfile />} />
            <Route exact path="/manage-tickets/*" element={<ManageTicket />} />
            <Route exact path="/repair-details/*" element={<RepairDetails />} />
            <Route exact path="/manage-parts" element={<ManageParts />} />
            <Route exact path="/ship-devices" element={<ShipDevices />} />
            <Route exact path="/mass-tickets" element={<MassTicket />} />
            <Route exact path="/outgoing-batches" element={<Outgoingbatches />} />
            <Route path="/manage-device/*" element={<ManageDeviceIndex />} />
            <Route path="/users/*" element={<IndexUsers />} />
            <Route path="/addupdate-users/*" element={<UsersAddUpdate />} />
            <Route path="/staff-members" element={<StaffMemberIndex />} />
            <Route exact path="/building" element={<Building />} />
            <Route exact path="/users-groups" element={<UsersGroup />} />
            <Route exact path="/inventory-audit" element={<InventoryAudit />} />
            <Route exact path="/previous-audits" element={<PreviousAudits />} />
            <Route exact path="/roles" element={<RolesIndex />} />
            <Route exact path="/custom-field" element={<DeviceCustomField />} />
        </Routes>
    )
}
